module.exports = __webpack_public_path__ + "img/payment_logos.e5b19ac9.png";